<template>
  <div>
    <div class="box">
      <div class="box-content">
          <div class="flex-xs">
              <div class="half-width-xs">
                  <div class="form-group">
                      <strong class="txt-primary mb-2 block">User can manage:</strong>
                      <div class="checkbox" v-for="user_role in user_roles">
                          <label>
                              <input type="checkbox"
                                     v-model="user_roles_list"
                                     :value="user_role.id"
                              >
                              <span class="checkbox-label">{{ user_role.description }}</span>
                          </label>
                      </div>
                  </div>
              </div>
              <div class="half-width-xs">
                  <transition name="fade-in">
                      <div class="form-group" v-show="hasRole(1)">
                          <strong class="txt-primary mb-2 block">Responsible for enquiry types:</strong>
                          <div class="checkbox" v-for="enquiry_type in enquiry_types">
                              <label>
                                  <input type="checkbox"
                                         v-model="enquiry_responsibilities_list"
                                         :value="enquiry_type.id"
                                  >
                                  <span class="checkbox-label">{{ enquiry_type.label }}</span>
                              </label>
                          </div>
                      </div>
                  </transition>
              </div>
          </div>
        <div class="mt-6 align-right">
          <a class="btn-primary" @click="updateRoles()">
            Update Roles
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
      'staff_user',
      'user_roles',
      'enquiry_types',
  ],
  mounted() {
    this.user_roles_list = this.staff_user.user_roles.map((user_role) => user_role.id);
    this.enquiry_responsibilities_list = this.staff_user.enquiry_responsibilities.map((user_responsibility) => user_responsibility.id);
  },
  data() {
    return {
      enquiry_responsibilities_list: [],
      user_roles_list: [],
    }
  },
  methods: {
    hasRole(role) {
      return this.user_roles_list.filter((user_role) => user_role === role).length > 0;
    },
    updateRoles() {
      axios.post('/update-staff-roles', {
        user_id: this.staff_user.id,
        enquiry_responsibilities_list: this.enquiry_responsibilities_list,
        user_roles_list: this.user_roles_list,
      }).then((response) => {
        Swal.fire({
          title: 'Roles Updated',
          icon: 'success',
          text: ''
        });
      });
    }
  },
};
</script>
